<template>
  <div class="gamesComment">
    <a-card>
      <a-tabs :default-active-key="activekey" @change="callback" class="gamesComment-tabs">
        <a-tab-pane key="1" tab="评价记录">
          <CommentRecord ref="CommentRecord"></CommentRecord>
        </a-tab-pane>
        <a-tab-pane key="2" tab="题目管理">
          <QuestionManage ref="QuestionManage"></QuestionManage>
        </a-tab-pane>
        <a-tab-pane key="3" tab="黑名单">
          <BlackList ref="BlackList"></BlackList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import CommentRecord from './components/CommentRecord'
import QuestionManage from './components/QuestionManage'
import BlackList from './components/BlackList'
export default {
  name: 'GamesComment',
  components: { CommentRecord, QuestionManage, BlackList },
  data() {
    return {
      activekey: this.$route.query.activekey ? this.$route.query.activekey : '1',
    }
  },
  mounted() {
    console.log(this.activekey)
  },
  methods: {
    callback(e) {
      this.$refs.CommentRecord.clearSearch()
      this.$refs.QuestionManage.clearSearch()
      this.$refs.BlackList.clearSearch()
    },
  },
}
</script>

<style>
.gamesComment-tabs {
  overflow: auto;
  height: 72.5vh;
}
</style>
